import styles from "./SideBlog.module.scss";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
const cx = classNames.bind(styles);
function SideBlog({ data }) {
    console.log(data);
    console.log("hình");
    // const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    return (
        <div className={cx("blog")}>
            <div className={cx("wrapper")}>
                <div className={cx("blog_item")}>
                    <img
                        alt=""
                        src="https://cdn.topteknews.net/wp-content/uploads/2022/07/27151742/image-lamborghini-huracan-sterrato-video-teaser-165888466276876.jpg"
                    />
                    <div className={cx("blog_info")}>
                        <h5 className={cx("blog_title")}>
                            Lorem ipsum, or lipsum as it is sometimes known, is
                            dummy text used in laying out print,
                        </h5>
                        <p>Lamborghini</p>
                    </div>
                </div>{" "}
                <div className={cx("blog_item")}>
                    <img
                        alt=""
                        src="https://cdn.topteknews.net/wp-content/uploads/2022/07/27151742/image-lamborghini-huracan-sterrato-video-teaser-165888466276876.jpg"
                    />
                    <div className={cx("blog_info")}>
                        <h5 className={cx("blog_title")}>
                            Lorem ipsum, or lipsum as it is sometimes known, is
                            dummy text used in laying out print,
                        </h5>
                        <p>Lamborghini</p>
                    </div>
                </div>{" "}
                <div className={cx("blog_item")}>
                    <img
                        alt=""
                        src="https://cdn.topteknews.net/wp-content/uploads/2022/07/27151742/image-lamborghini-huracan-sterrato-video-teaser-165888466276876.jpg"
                    />
                    <div className={cx("blog_info")}>
                        <h5 className={cx("blog_title")}>
                            Lorem ipsum, or lipsum as it is sometimes known, is
                            dummy text used in laying out print,
                        </h5>
                        <p>Lamborghini</p>
                    </div>
                </div>{" "}
                <div className={cx("blog_item")}>
                    <img
                        alt=""
                        src="https://cdn.topteknews.net/wp-content/uploads/2022/07/27151742/image-lamborghini-huracan-sterrato-video-teaser-165888466276876.jpg"
                    />
                    <div className={cx("blog_info")}>
                        <h5 className={cx("blog_title")}>
                            Lorem ipsum, or lipsum as it is sometimes known, is
                            dummy text used in laying out print,
                        </h5>
                        <p>Lamborghini</p>
                    </div>
                </div>{" "}
                <Link to="" className={cx("more_btn")}>
                    Xem thêm
                    <div>
                        <FontAwesomeIcon icon={faAngleDown} />
                    </div>
                </Link>
            </div>
            {data}
        </div>
    );
}

export default SideBlog;
